import { useRouteMatch } from 'react-router-dom';

export const useLandingRouteParams = () => {
  const routeMatch = useRouteMatch<{ id: string }>({
    exact: true,
    path: [
      '/u/:id(\\d+|demo)/',
      '/u/:id(\\d+|demo)',
      '/o/:org([a-z0-9-]+)/:id(\\d+)/',
      '/o/:org([a-z0-9-]+)/:id(\\d+)',
      '/',
    ],
  });

  if (!routeMatch) {
    return null;
  }

  return routeMatch?.params;
};

export const useVoiceboxRouteParams = () => {
  const routeMatch = useRouteMatch<{
    org?: string;
    id: string;
    conversation?: string;
  }>({
    exact: true,
    path: [
      '/u/:id(\\d+)/voicebox/:conversation?',
      '/o/:org([a-z0-9-]+)/:id(\\d+)/voicebox/:conversation?',
    ],
  });

  if (!routeMatch) {
    return null;
  }

  return routeMatch?.params;
};
